/**
  按需引入iview，将需要用到的组件按如下方式添加
*/
import Vue from 'vue'
import '@/assets/iview-theme/build/iview.css'
import {
  Button,
  Notice,
  Icon,
  Row,
  Message,
  Badge,
  DatePicker,
  Table,
  Tag,
  Tabs,
  TabPane,
  Page,
  Tooltip,
  Poptip,
  CheckboxGroup,
  Checkbox,
  RadioGroup,
  Radio,
  Spin,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Switch,
  Modal,
  Col,
  Menu,
  Submenu,
  MenuItem,
  TimePicker,
  Form,
  FormItem,
  Card,
  Input,
  Divider,
  InputNumber,
  Breadcrumb,
  BreadcrumbItem
} from 'iview'
import PanelDatePicker from '@components/datePicker'
import LocalCheckboxGroup from '@components/iview/checkbox-group'
import LocalCheckbox from '@components/iview/checkbox'

Vue.component('InputNumber', InputNumber)
Vue.component('Button', Button)
Vue.component('i-button', Button) // tsx 模式下
Vue.component('Icon', Icon)
Vue.component('i-icon', Icon)
Vue.component('Row', Row)
Vue.component('Badge', Badge)
Vue.component('DatePicker', DatePicker)
Vue.component('i-date-picker', DatePicker)
Vue.component('i-panel-date-picker', PanelDatePicker)
Vue.component('Table', Table)
Vue.component('i-table', Table) // tsx 模式下
Vue.component('Tag', Tag)
Vue.component('Tabs', Tabs)
Vue.component('i-tabs', Tabs)
Vue.component('TabPane', TabPane)
Vue.component('i-tab-pane', TabPane)
Vue.component('Page', Page)
Vue.component('Tooltip', Tooltip)
Vue.component('i-tooltip', Tooltip)
Vue.component('Poptip', Poptip)
Vue.component('i-poptip', Poptip)
Vue.component('CheckboxGroup', CheckboxGroup)
Vue.component('i-checkbox-group', CheckboxGroup)
Vue.component('local-checkbox-group', LocalCheckboxGroup)
Vue.component('Checkbox', Checkbox)
Vue.component('i-checkbox', Checkbox)
Vue.component('local-checkbox', LocalCheckbox)
Vue.component('checkbox-group', CheckboxGroup)
Vue.component('checkbox', Checkbox)
Vue.component('RadioGroup', RadioGroup)
Vue.component('i-radio-group', RadioGroup)
Vue.component('Radio', Radio)
Vue.component('i-radio', Radio)
Vue.component('Spin', Spin)
Vue.component('Dropdown', Dropdown)
Vue.component('DropdownMenu', DropdownMenu)
Vue.component('DropdownItem', DropdownItem)
Vue.component('iSwitch', Switch)
Vue.component('Modal', Modal)
Vue.component('Col', Col)
Vue.component('i-col', Col) // tsx 模式下
Vue.component('Menu', Menu)
Vue.component('Submenu', Submenu)
Vue.component('MenuItem', MenuItem)
Vue.component('TimePicker', TimePicker)
Vue.component('Form', Form)
Vue.component('i-form', Form) // tsx 模式下
Vue.component('FormItem', FormItem)
Vue.component('i-form-item', FormItem)
Vue.component('Card', Card)
Vue.component('Input', Input)
Vue.component('i-input', Input) // tsx 模式下
Vue.component('Divider', Divider)
Vue.component('Breadcrumb', Breadcrumb)
Vue.component('BreadcrumbItem', BreadcrumbItem)

// 当datepicker 默认open=true时 需要重写handleClose 否则会阻止页面其他事件的冒泡
DatePicker.mixins[0].methods.handleClose = function(e) {
  // props的open=true不继续往下走阻止冒泡
  if (this.disableCloseUnderTransfer || this.open) {
    this.disableCloseUnderTransfer = false
    return false
  }

  if (e && e.type === 'mousedown' && this.visible) {
    e.preventDefault()
    e.stopPropagation()
    return
  }

  if (this.visible) {
    const pickerPanel = this.$refs.pickerPanel && this.$refs.pickerPanel.$el
    if (e && pickerPanel && pickerPanel.contains(e.target)) return // its a click inside own component, lets ignore it.

    this.visible = false
    e && e.preventDefault()
    e && e.stopPropagation()
    this.$emit('on-clickoutside', e)
    return
  }

  this.isFocused = false
  this.disableClickOutSide = false
}

// 绑定方式见 src/shims-vue.d.ts
Vue.prototype.$Message = Message
Vue.prototype.$Spin = Spin
Vue.prototype.$Modal = Modal
Vue.prototype.$Notice = Notice
